import { View } from "@/components/ui/view";
import { VStack } from "@/components/ui/vstack";
import { ScrollView } from 'react-native-gesture-handler';

import i18n from 'i18n-js';
import React, { useEffect, useState } from 'react';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch } from "react-redux";
import Footer from "@/components/basic/Footer";
import SwitchableElement from '@/components/basic/SwitchableElement';
import useIsMounted from '@/hooks/mounted';
import SelectableElement from '@/components/basic/SelectableElement';
import { taskSettings } from "@/stores/mainSlice";

export default function TaskSettings({ route, navigation }) {
    const { task } = route.params

    const dispatch = useDispatch()
    const mounted = useIsMounted()
    const insets = useSafeAreaInsets()

    const categories = ['taskSettings.home', 'taskSettings.garden', 'taskSettings.allday', 'taskSettings.medic', 'taskSettings.diy', 'taskSettings.cook', 'taskSettings.other'].map(cat => i18n.t(cat))

    const [strict, setStrict] = useState(task?.settings?.strict || false)
    const [category, setCategory] = useState((+task?.settings?.category || 7) - 1);

    useEffect(() => {
        navigation.setOptions({ info: task.title })
    }, [])

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (strict != task?.settings?.strict || category != task?.settings?.category) {
                    dispatch(taskSettings({ taskid: task.id, settings: { strict: strict, category: +category + 1 } }))
                }
            }
        };
    }, [mounted])

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 90 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3">
                <VStack space='xl'>
                    <SwitchableElement header={i18n.t('taskSettings.execute')} mainText={i18n.t('taskSettings.strict')} isChecked={strict} onToggle={() => setStrict(!strict)} />
                    {true && <SelectableElement header={i18n.t('taskSettings.category')} mainText={i18n.t('taskSettings.category')} selections={categories} selected={category} setSelected={setCategory} />}
                </VStack>
            </ScrollView>
            <Footer navigation={navigation} />
        </View>
    );
}
